import { Service, inject } from '@angular/core'
import { DeleteEntityResponse, GetPublicReservationQuery, PublicReservation } from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class PublicReservationApiService {
  private readonly api = inject(ApiService)

  getReservation(reservationId: string, query: GetPublicReservationQuery, init?: RequestInit) {
    const url = this.api.createURL(`reservations/${reservationId}`)
    url.search = this.api.toQueryParams(query)
    return this.api.fetchJson<PublicReservation>(url, { ...init })
  }

  deleteReservation(reservationId: string, query: GetPublicReservationQuery, init?: RequestInit) {
    const url = this.api.createURL(`reservations/${reservationId}`)
    url.search = this.api.toQueryParams(query)
    return this.api.fetchJson<DeleteEntityResponse>(url, { method: 'DELETE', ...init })
  }
}
